<template>
    <div class="all_1">
      <login_top1></login_top1>
      <div class="all_cen" :style="{background: 'url('+$store.state.Url+img+')'}" style="background-size: 100% 100%;">
        <div class="all_cen_text">
          <el-form :model="form" :rules="rules" ref="ruleForm" label-width="100px">
            <el-form-item label="登录名" prop="user_name">
              <el-input v-model="form.user_name" style="width: 320px"></el-input>
            </el-form-item>
            <el-form-item label="登录密码" prop="pwd">
              <el-input v-model="form.pwd" show-password style="width: 320px"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="pass">
              <el-input v-model="form.pass" show-password style="width: 320px"></el-input>
            </el-form-item>
            <el-form-item label="真实姓名" prop="real_name">
              <el-input v-model="form.real_name" style="width: 320px"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" prop="phone">
              <el-input v-model="form.phone" style="width: 320px"></el-input>
            </el-form-item>
            <el-form-item label="手机验证码" prop="code">
              <el-input v-model="form.code" style="width: 320px"></el-input>
            </el-form-item>
            <el-form-item label="电子邮箱" prop="email">
              <el-input v-model="form.email" style="width: 320px"></el-input>
            </el-form-item>
            <el-form-item label="所在地">
              <el-select v-model="form.pro_id" placeholder="请选择省" @change="getAdd(form.pro_id)">
                <el-option :label="val.name" :value="val.id" v-for="(val,key) in adds" :key="key"></el-option>
              </el-select>
              <el-select v-model="form.city_id" placeholder="请选择市" @change="getAdd1(form.city_id)">
                <el-option :label="val.name" :value="val.id" v-for="(val,key) in adds1" :key="key"></el-option>
              </el-select>
              <el-select v-model="form.area_id" placeholder="请选择区/县">
                <el-option :label="val.name" :value="val.id" v-for="(val,key) in adds2" :key="key"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="街道门牌" prop="add_ress">
              <el-input v-model="form.add_ress" style="width: 320px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleForm')">注册</el-button>
            </el-form-item>
          </el-form>
          <p>{{form.region}}</p>
        </div>
      </div>
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import Pagetail from '../assembly/Pagetail'
  import login_top1 from '../assembly/login_top1'
  import {getreg,getCity,getimage} from '../api/loginred'
    export default {
        name: "register",
        components:{
          Pagetail,login_top1
        },
      data(){
          return{
            adds:[],
            adds1:[],
            adds2:[],
            form: {
              pro_id:'',//省 ID
              pro_name:'',//省 ID
              city_id:'',//市 ID
              city_name:'',//市 ID
              area_id:'',//区县 ID
              area_name:'',//区县 ID
              user_name:'',//账号名
              pwd:'',//密码
              pass:'',//确认密码
              real_name:'',//真实姓名
              phone:'',//手机号
              code:'',//手机验证码
              email:'',//邮箱
              add_ress:'',//街道 详细地址
            },
            rules:{
              user_name: [
                { required: true, message: '请输入登录名', trigger: 'blur' },
              ],
              pwd: [
                { required: true, message: '请输入登录密码', trigger: 'blur' },
              ],
              pass: [
                { required: true, message: '请输入确认密码', trigger: 'blur' },
              ],
              real_name: [
                { required: true, message: '请输入真实姓名', trigger: 'blur' },
              ],
              phone: [
                { required: true, message: '请输入手机号码', trigger: 'blur' },
              ],
          /*    code: [
                { required: true, message: '请输入手机验证码', trigger: 'blur' },
              ],*/
              email: [
                { required: true, message: '请输入电子邮箱', trigger: 'blur' },
              ],
              add_ress: [
                { required: true, message: '请输入街道门牌', trigger: 'blur' },
              ],
            },
            img:''
          }
      },
      mounted() {
        this.init()
      },
      methods: {
        getAdd(e){
          getCity({parentid:e}).then(res=>{
            this.adds1 = res.result
          })
        },
        getAdd1(e){
          getCity({parentid:e}).then(res=>{
            this.adds2 = res.result
          })
        },
          init(){
            getCity({}).then(res=>{
              this.adds = res.result
            })
            getimage({}).then(res=>{
              this.img = res.result.reg_img
            })
          },
        submitForm(formName) {
          this.$refs[formName].validate((valid) => {
            if (valid) {
              this.getReg()
            } else {
              console.log('error submit!!');
              return false;
            }
          });
        },
        getReg(){
          getreg(this.form).then(res=>{
            this.$router.push({path:'/login'})
          })
        }
      },
    }
</script>

<style scoped lang="less">
 @import "css/register";
</style>



// WEBPACK FOOTER //
// src/components/register.vue